<template>
    <li
        v-for="(className, classCodeFromList) in classLists"
        :key="classCodeFromList"
        class="menu-item menu-item--class"
    >
        <img src="/images/home-game/icons/person.svg" alt="person" />
        <span>
            {{ className }}
            <br />
            <span class="menu-item__code">
                Class code: {{ classCodeFromList }}
            </span>
        </span>
    </li>
    <slot name="trigger">
        <li class="menu-button" @click="openClassInfoModal(null)">
            <img src="/images/team.svg" alt="team" />
            <span>
                {{ $t('accountLinking.joinClass') }}
            </span>
        </li>
    </slot>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    props: {
        showJoinButton: {
            type: Boolean,
            default: true,
        },
        showClasses: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        ...mapGetters(['user']),
        classLists() {
            return this.user?.studentInfo?.classLists || [];
        },
    },
    methods: {
        openClassInfoModal() {
            this.$router.push({ name: 'home-game.v10.join-class' });
        },
    },
};
</script>
